<template>
  <div class="schoolinfo-banner">
    <div class="banner-upload">
      <el-upload class="upload" :auto-upload="false" :action="action" list-type="picture-card" accept=".jpg,.png,.jpeg"
        multiple :http-request="uploadFile" ref="upload" :limit="3" :on-change="onChange" :on-remove="onRemove"
        :on-preview="handlePictureCardPreview" :on-exceed="onExceed" :file-list="fileList">
        <img class="add" src="~@/assets/image/schoolinfo/add.png" />
      </el-upload>
      <div class="line"></div>
      <div class="upload-btn">
        <!-- <div class="cancel" @click="editShow = false">取消</div> -->
        <!-- <div class="submit" @click="submitForm">保存</div> -->
      </div>
    </div>
    <!-- <div class="banner-image" v-show="!editShow">
      <div class="image">
        <ul class="image-list" v-show="imgList.length">
          <li v-for="(item, index) in imgList" :key="index">
            <el-image :src="item" fit="cover" @click="imgPreview(item, index)" style="width: 100%; height: 100%" />
          </li>
        </ul>
        <div v-show="!imgList.length" class="empty">
          <img src="~@/assets/image/schoolinfo/empty.png" alt="" />暂无轮播图
        </div>
      </div>
      <div class="line"></div>
      <div class="edit" @click="editShow = true" v-hasPermi="'sc:school:edit'">编辑</div>
    </div> -->
    <el-dialog width="750px" style="text-align: center" :visible.sync="dialogVisibleByOne">
      <img width="50%" :src="dialogImageUrl" alt="" />
      <el-upload ref="uploadOneImage" :auto-upload="false" style="margin-top: 20px;" list-type="picture-card"
        accept=".jpg,.png,.jpeg" :http-request="uploadFileByOne" :action="actionByOne" :on-exceed="onExceedByOne"
        :limit="1" :file-list="oneImgFileList" :on-change="onChangeByOne">
        点击更换新图片
      </el-upload>
      <el-button style="margin-top: 20px;" type="primary" v-show="oneImgFileList.length > 0" @click="oneImagePut">确认更换</el-button>
    </el-dialog>
    <el-dialog width="750px" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

import { baseURL } from "@/api/request"; // 服务器地址
export default {
  name: "",
  data() {
    return {
      editShow: false, // 是否编辑
      formDate: new FormData(),  // 文件上传参数
      formDateByOne: "", // 文件上传参数 修改单个轮播图
      action: "", // 文件上传路径 
      actionByOne: "", // 文件上传路径 修改单个轮播图
      //
      bannerList: "",
      oneImgIndex: 0, // 修改单个轮播图 下标
      // bannerList:
      // "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg,https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg,https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      // 图片
      imgList: [],
      // 待提交的图片
      fileList: [],
      oneImgFileList: [], // 修改单个轮播图上传列表
      // 预览参数
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVisibleByOne: false, // 修改单个轮播图上传列表 弹窗
      count: 1,
    };
  },
  created() {
    // console.log("baseURL==>", baseURL);
    this.action = `${baseURL}${this.$url.insertSlideshowPC}`;
    this.actionByOne = `${baseURL}${this.$url.putBannerOneImage}`;

    setTimeout(() => {
      if (this.school.imageList) {
        // console.log("this.school.imageList==>", this.school.imageList);
        this.imgList = this.school.imageList.split(",");
        this.imgList.forEach((item) => {
          // this.imgUrlToFile(item); //将图片url转化成file文件
          this.fileList.push({
            name: item.split('/').pop(),
            url: item,
            // 假设默认图片没有 raw 文件对象
            raw: null // 或者 undefined
          });
        });
      }
    }, 1000);
  },
  methods: {
    imgUrlToFile(url) {
      var self = this;
      var tempImage = new Image();
      //如果图片url是网络url，要加下一句代码
      tempImage.crossOrigin = "*";
      tempImage.onload = function () {
        var base64 = self.getBase64Image(tempImage);
        var imgblob = self.base64toBlob(base64);
        var filename = self.getFileName(url);
        self.blobToFile(imgblob, filename, url);
      };
      tempImage.src = url;
      // console.log("tempImage:", tempImage);

    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      var dataURL = canvas.toDataURL("image/" + ext);
      return dataURL;
    },
    base64toBlob(base64) {
      let arr = base64.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    blobToFile(blob, filename, url) {
      // edge浏览器不支持new File对象，所以用以下方法兼容
      blob.lastModifiedDate = new Date();
      blob.name = filename;
      let file = new File([blob], filename, { type: blob.type }); //file的对象在上传时,需要文件 而不是blob对象
      file.uid = file.lastModified;
      var person = new Object();
      person.name = file.name;
      person.percentage = 0;
      person.raw = file;
      person.size = file.size;
      person.status = "ready";
      person.uid = file.uid;
      person.url = url;
      this.fileList.push(person); //将原有的图片生成的文件，添加到待提交图片里
    },
    getFileName(url) {
      // 获取到文件名
      let pos = url.lastIndexOf("/"); // 查找最后一个/的位置
      return url.substring(pos + 1); // 截取最后一个/位置到字符长度，也就是截取文件名
    },
    // 普通图片预览
    imgPreview(url, index) {
      this.oneImgFileList = [];
      this.oneImgIndex = index;
      this.dialogImageUrl = url;
      this.dialogVisibleByOne = true;
    },
    // 上传预览图片时调用
    handlePictureCardPreview(file) {
      // 只允许预览已上传的文件
      if (file.status === "success") {
        this.oneImgFileList = [];
        // 获取当前预览文件在 fileList 中的索引
        const index = this.getFileIndexByName(file.name);
        this.oneImgIndex = index; // 存储索引值
        this.dialogImageUrl = file.url;
        this.dialogVisibleByOne = true;
      } else {
        this.$message.warning('请先保存上传图片');
      }
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },
    // 获取图片下标
    getFileIndexByName(name) {
      return this.fileList.findIndex(item => item.name === name);
    },
    // 文件超出个数限制时
    onExceed(file, fileList) {
      return this.$message("最多可上传三张");
    },
    onExceedByOne(file, fileList) {
      return this.$message("最多可上传一张");
    },
    // 添加文件、上传成功和上传失败时都会被调用
    onChange(file, fileList) {
      let limit = file.size / 1024 / 1024 < 2;
      let file_type = file.name.split(".")[1];
      if (!/^(jpg|png|jpeg)$/g.test(file_type)) {
        this.$refs.upload.clearFiles();
        return this.$message.warning("请选择jpg,png,jpeg类型文件");
      } else if (!limit) {
        this.$refs.upload.clearFiles();
        return this.$message.warning("上传图片大小不能超过 2MB!");
      } else {
        this.fileList = fileList;
        // console.log("file:", file);
        this.insertSlideshowPC(file);

        // console.log("onChange(file, fileList) =>",this.fileList)
      }
    },
    insertSlideshowPC(file) {
      // new FormData()创建创建FormData对象
      this.formDate = new FormData();
      this.formDate.append(`file`, file.raw);
      this.formDate.append("schoolId", this.user.schoolId);
      let config = {
        headers: {
          bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(this.action, this.formDate, config)
        .then((res) => {
          // res.data 服务器返回的数据
          let data = res.data;
          if (res.status != 200) {
            return this.$message.error("上传失败");
          } else {
            if (data.code == 200) {
              // 上传成功
              this.$store
                .dispatch("school/getSchool", { id: this.school.id })
                .then((res) => {
                  this.fileList = [];
                  if (this.school.imageList) {
                    this.imgList = this.school.imageList.split(",");
                    this.imgList.forEach((item) => {
                      this.fileList.push({
                        name: item.split('/').pop(),
                        url: item,
                        // 假设默认图片没有 raw 文件对象
                        raw: null // 或者 undefined
                      });
                    });
                  } else {
                    this.imgList = this.school.imageList;
                  };
                  this.$message.success("修改成功");
                })
                .catch((err) => {
                  this.$message.error("获取最新信息失败");
                });
            } else if (data.code == 401 || data.code == 403) {
              // token失效
              this.$message.error("获取用户信息失败，请重新登录");
              this.$store.dispatch("user/resetToken");
              this.$router.replace({
                path: "login",
                query: { redirect: this.$router.currentRoute.fullPath },
              });
            } else {
              this.$message.error("修改失败");
            }
          }
        })
        .catch((res) => {
          this.count = 1;
          return this.$message.error("上传失败，请稍后再试");
        });
    },
    onChangeByOne(file, fileList) {
      let limit = file.size / 1024 / 1024 < 2;
      let file_type = file.name.split(".")[1];
      if (!/^(jpg|png|jpeg)$/g.test(file_type)) {
        this.$refs.upload.clearFiles();
        return this.$message.warning("请选择jpg,png,jpeg类型文件");
      } else if (!limit) {
        this.$refs.upload.clearFiles();
        return this.$message.warning("上传图片大小不能超过 2MB!");
      } else {
        this.oneImgFileList = fileList;
        // console.log("onChange(file, fileList) =>",this.oneImgFileList)
      }
    },
    // 移除图片时被调用
    onRemove(file, fileList) {
      // console.log("file:", file);
      // 获取当前预览文件在 fileList 中的索引
      const index = this.getFileIndexByName(file.name);
      // new FormData()创建创建FormData对象
      this.formDate = new FormData();
      this.formDate.append("schoolId", this.user.schoolId);
      this.formDate.append("imageIndex", index);
      let config = {
        headers: {
          bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
          "Content-Type": "multipart/form-data",
        },
      };

      // console.log("配置", this.action, this.formDate, config);
      // 调用接口
      axios
        .post(this.actionByOne, this.formDate, config)
        .then((res) => {
          // res.data 服务器返回的数据
          let data = res.data;
          if (res.status != 200) {
            return this.$message.error("删除失败");
          } else {
            if (data.code == 200) {
              // 上传成功
              this.$store
                .dispatch("school/getSchool", { id: this.school.id })
                .then((res) => {
                  this.fileList = [];
                  if (this.school.imageList) {
                    this.imgList = this.school.imageList.split(",");
                    this.imgList.forEach((item) => {
                      // this.imgUrlToFile(item); //将图片url转化成file文件
                      this.fileList.push({
                        name: item.split('/').pop(),
                        url: item,
                        // 假设默认图片没有 raw 文件对象
                        raw: null // 或者 undefined
                      });
                    });
                  } else {
                    this.imgList = this.school.imageList;
                  }
                  this.$message.success("删除成功");
                })
                .catch((err) => {
                  this.$message.error("获取最新信息失败");
                });
            } else if (data.code == 401 || data.code == 403) {
              // token失效
              this.$message.error("获取用户信息失败，请重新登录");
              this.$store.dispatch("user/resetToken");
              this.$router.replace({
                path: "login",
                query: { redirect: this.$router.currentRoute.fullPath },
              });
            } else {
              this.$message.error(data.msg);
            }
          }
        })
        .catch((res) => {
          return this.$message.error("删除失败，请稍后再试");
        });
    },
    // 覆盖默认的上传行为，可以自定义上传的实现
    // 向FormData对象设置文件
    uploadFile(file) {
      // console.log("uploadFile(file) =>", file)
      // this.formDate.append(`image${this.count}`, file.file);
      // this.formDate.append("file", file.file);
      // this.count++;
    },
    uploadFileByOne(file) {
      // console.log("uploadFile(file) =>",file.file)
      this.formDateByOne.append("file", file.file);
    },
    // 提交
    submitForm() {
      // console.log(this.fileList);

      // 未选择图片
      // if (!this.fileList.length) {
      //   return this.$message.error("未选择图片");
      // }
      // new FormData()创建创建FormData对象
      this.formDate = new FormData();
      // this.$refs.upload.submit(); // => 会调用uploadFile(file)

      // 处理默认图片
      this.fileList.forEach((file, index) => {
        // console.log(file);

        if (file.url && !file.raw) { // 如果是默认图片（没有 raw 文件）
          // const hexFileName = this.generateBinaryLikeFileName(file.url);
          const hexFileName = file.name;
          const blob = new Blob([file.url], { type: 'image/png' });
          // 创建一个虚拟文件对象
          const virtualFile = new File([blob], hexFileName, { type: 'image/png' });

          console.log(virtualFile);
          // this.formDate.append(`file`, file.url); // 直接上传图片URL

          this.formDate.append(`file`, virtualFile); // 添加虚拟文件对象到 FormData
        } else if (file.raw) { // 如果是新上传的文件
          console.log("raw:", file.raw);

          this.formDate.append(`file`, file.raw);
        }
      });

      // 向FormData对象设置其他参数
      let user = this.user;
      // console.log(user);
      this.formDate.append("id", user.schoolId);
      this.formDate.append("updateBy", user.id);
      let config = {
        headers: {
          bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
          "Content-Type": "multipart/form-data",
        },
      };
      // console.log("配置", this.action, this.formDate, config);
      // 调用接口
      axios
        .post(this.action, this.formDate, config)
        .then((res) => {
          // console.log(res);
          this.count = 1;
          // res.data 服务器返回的数据
          let data = res.data;
          console.log(data);
          if (res.status != 200) {
            return this.$message.error("上传失败");
          } else {
            if (data.code == 200) {
              // 上传成功
              this.$store
                .dispatch("school/getSchool", { id: this.school.id })
                .then((res) => {
                  // console.log("上传==>", res);
                  // console.log('this.school==>',this.school);
                  this.fileList = [];
                  if (this.school.imageList) {
                    this.imgList = this.school.imageList.split(",");
                    this.imgList.forEach((item) => {
                      // console.log("item:", item);

                      // this.imgUrlToFile(item); //将图片url转化成file文件
                      this.fileList.push({
                        name: item.split('/').pop(),
                        url: item,
                        // 假设默认图片没有 raw 文件对象
                        raw: null // 或者 undefined
                      });
                    });
                    // console.log(this.imgList, this.fileList);

                  } else {
                    this.imgList = this.school.imageList;
                  };
                  this.$message.success("修改成功");
                  this.editShow = false;
                })
                .catch((err) => {
                  this.$message.error("获取最新信息失败");
                });
            } else if (data.code == 401 || data.code == 403) {
              // token失效
              this.$message.error("获取用户信息失败，请重新登录");
              this.$store.dispatch("user/resetToken");
              this.$router.replace({
                path: "login",
                query: { redirect: this.$router.currentRoute.fullPath },
              });
            } else {
              this.$message.error("修改失败");
            }
          }
        })
        .catch((res) => {
          this.count = 1;
          return this.$message.error("上传失败，请稍后再试");
        });
    },
    generateBinaryLikeFileName(url) {
      const ext = url.split('.').pop(); // 获取文件扩展名
      const namePart = url.split('/').pop().split('.')[0]; // 获取文件名部分（不带扩展名）

      // 生成随机的二进制样式的字符串
      const array = new Uint8Array(16); // 使用较小的数组以避免过长的文件名
      window.crypto.getRandomValues(array);
      let binaryString = '';
      for (let i = 0; i < array.length; i++) {
        // 将每个字节转换成8位二进制字符串，并连接起来
        binaryString += array[i].toString(6).padStart(4, '0');
      }

      return `${binaryString}.${ext}`; // 返回新的文件名
    },
    // 修改单个轮播图
    oneImagePut() {
      // new FormData()创建创建FormData对象
      this.formDateByOne = new FormData();
      this.$refs.uploadOneImage.submit(); // => 会调用uploadFile(file)

      // 向FormData对象设置其他参数
      let user = this.user;
      // console.log(user);
      this.formDateByOne.append("schoolId", user.schoolId);
      this.formDateByOne.append("imageIndex", this.oneImgIndex);
      let config = {
        headers: {
          bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
          "Content-Type": "multipart/form-data",
        },
      };
      // console.log("配置", this.action, this.formDate, config);
      // 调用接口
      axios
        .post(this.actionByOne, this.formDateByOne, config)
        .then((res) => {
          // console.log(res);
          // res.data 服务器返回的数据
          let data = res.data;
          // console.log(data);
          if (res.status != 200) {
            return this.$message.error("上传失败");
          } else {
            if (data.code == 200 && data.data > 0) {
              // 上传成功
              this.$store
                .dispatch("school/getSchool", { id: this.school.id })
                .then((res) => {
                  // console.log("上传==>", res);
                  // console.log('this.school==>',this.school);
                  this.fileList = [];
                  if (this.school.imageList) {
                    this.imgList = this.school.imageList.split(",");
                    this.imgList.forEach((item) => {
                      // this.imgUrlToFile(item); //将图片url转化成file文件
                      this.fileList.push({
                        name: item.split('/').pop(),
                        url: item,
                        // 假设默认图片没有 raw 文件对象
                        raw: null // 或者 undefined
                      });
                    });
                  } else {
                    this.imgList = this.school.imageList;
                  }
                  this.$message.success("修改成功");
                  this.dialogVisibleByOne = false;
                })
                .catch((err) => {
                  this.$message.error("获取最新信息失败");
                });
            } else if (data.code == 401 || data.code == 403) {
              // token失效
              this.$message.error("获取用户信息失败，请重新登录");
              this.$store.dispatch("user/resetToken");
              this.$router.replace({
                path: "login",
                query: { redirect: this.$router.currentRoute.fullPath },
              });
            } else {
              this.$message.error(data.msg);
            }
          }
        })
        .catch((res) => {
          this.count = 1;
          return this.$message.error("上传失败，请稍后再试");
        });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./schoolinfo-banner.scss";
</style>
